module.exports = __webpack_public_path__ + "img/icon_logo.eb3627ce.png";